import { render } from "./ScNormalPageLayout.vue?vue&type=template&id=0f1faddb"
import script from "./ScNormalPageLayout.vue?vue&type=script&lang=js"
export * from "./ScNormalPageLayout.vue?vue&type=script&lang=js"

import "./ScNormalPageLayout.vue?vue&type=style&index=0&id=0f1faddb&lang=css"

import exportComponent from "/home/runner/work/webapp/webapp/main/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__